import { useEffect, useRef } from 'react';
import type { FitBoundsOptions, LatLngBounds } from 'leaflet';
import { useMap } from 'react-leaflet';
import { isUsableLatLngBounds, safeFitBounds } from '../../utils/leafletBounds';

/** Prefer this over MapContainer `bounds` — avoids fitBounds during attach with zero-size containers. */
export function FitMapBounds({
  bounds,
  options,
  once = false,
}: {
  bounds: LatLngBounds;
  options?: FitBoundsOptions;
  /** When true, fit only on first mount (preserves user zoom/pan after selector changes). */
  once?: boolean;
}) {
  const map = useMap();
  const didFitRef = useRef(false);
  useEffect(() => {
    if (!isUsableLatLngBounds(bounds)) return;
    if (once && didFitRef.current) return;
    safeFitBounds(map, bounds, options);
    if (once) didFitRef.current = true;
  }, [map, bounds, options, once]);
  return null;
}
